import moment from "moment/moment";

export const setSelectedCountry = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);

    orderData[state.activeOrderDataIndex]['continent_id'] = payload.continent.id;
    orderData[state.activeOrderDataIndex]['country_id'] = payload.id;
    orderData[state.activeOrderDataIndex]['country_name'] = payload.name;
    orderData[state.activeOrderDataIndex]['country_api_id'] = payload.api_country_id;

    state.orderData = orderData;
};

export const setPlanType = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);

    orderData[state.activeOrderDataIndex]['plan_type'] = payload;

    state.orderData = orderData;
};

export const setSelectedDevice = (state, payload) => {
    state.selectedDevice = payload;
    
    let orderData = _.cloneDeep(state.orderData);

    orderData[state.activeOrderDataIndex]['device_id'] = payload.id || null;
    orderData[state.activeOrderDataIndex]['device_type'] = payload.type || '1';
    orderData[state.activeOrderDataIndex]['device_extra_charge'] = payload.extra_charge || 0;

    state.orderData = orderData;
};

export const setStartDate = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['start_date'] = payload;
    state.orderData = orderData;
};

export const setEndDate = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['end_date'] = payload;
    state.orderData = orderData;
};

export const setNumberOfDays = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['number_of_days'] = payload;
    state.orderData = orderData;
};

export const toggleReturnDate = (state) => {
    let orderData = _.cloneDeep(state.orderData);
    let numToAdd = 5;
    let startDate = orderData[state.activeOrderDataIndex]['start_date'];
    let endDate = null;
    let numberOfDays = orderData[state.activeOrderDataIndex]['number_of_days'];
    let planType = orderData[state.activeOrderDataIndex]['plan_type'];

    switch (planType) {
        case 'day':
            endDate = moment(startDate).add(numberOfDays, 'days');
            break;
        case 'month':
            endDate = moment(startDate).add(numberOfDays, 'months');
            break;
    }

    if (endDate) {
        endDate.add(numToAdd, 'days');

        if (endDate.day() === 0) {
            endDate.add(1, 'days');
        } else if (endDate.day() === 6) {
            endDate.add(2, 'days');
        }
    }

    orderData[state.activeOrderDataIndex]['return_date'] = endDate.format('MM/DD/YYYY');
    state.orderData = orderData;
};

export const setNumberOfDevices = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);

    orderData[state.activeOrderDataIndex]['number_of_devices'] = payload;

    state.orderData = orderData;
};

export const setSelectedPlan = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);

    orderData[state.activeOrderDataIndex]['plan_id'] = payload.id;
    orderData[state.activeOrderDataIndex]['plan_name'] = payload.name;
    orderData[state.activeOrderDataIndex]['plan_amount'] = payload.price;

    state.orderData = orderData;
};

export const setShipmentType = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['shipment_type'] = payload;
    state.orderData = orderData;
};

export const setPickupLocation = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['pickup_location_id'] = payload.id || null;
    orderData[state.activeOrderDataIndex]['pickup_location_api_id'] = payload.api_pickup_location_id|| null;
    orderData[state.activeOrderDataIndex]['pickup_location_name'] = payload.name || null;
    orderData[state.activeOrderDataIndex]['pickup_location_note'] = payload.time_note || null;
    state.orderData = orderData;
};

export const setPickupDate = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['pickup_date'] = payload;
    state.orderData = orderData;
};

export const setDeliveryType = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['delivery_type_id'] = payload.id || null;
    orderData[state.activeOrderDataIndex]['delivery_type_api_id'] = payload.api_shipping_type_id || null;
    orderData[state.activeOrderDataIndex]['delivery_type_charges'] = payload.charges || 0;
    orderData[state.activeOrderDataIndex]['delivery_type_name'] = payload.name || null;
    orderData[state.activeOrderDataIndex]['delivery_type_description'] = payload.description || null;
    state.orderData = orderData;
};

export const setDeliveryForm = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['address'] = payload.address || null;
    orderData[state.activeOrderDataIndex]['city'] = payload.city || null;
    orderData[state.activeOrderDataIndex]['country'] = payload.country || null;
    orderData[state.activeOrderDataIndex]['state'] = payload.state || null;
    orderData[state.activeOrderDataIndex]['zip_code'] = payload.zip_code || null;
    state.orderData = orderData;
};

export const setCoupon = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['coupon_id'] = payload.id || null;
    orderData[state.activeOrderDataIndex]['coupon_code'] = payload.coupon_name || '';
    orderData[state.activeOrderDataIndex]['coupon_type'] = payload.discount_type || null;
    orderData[state.activeOrderDataIndex]['coupon_discount_amount'] = payload.discount_amount || 0;
    state.orderData = orderData;
};

export const setGiftCard = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['gift_card_id'] = payload.id;
    orderData[state.activeOrderDataIndex]['gift_card_code'] = payload.code;
    orderData[state.activeOrderDataIndex]['gift_discount_amount'] = payload.amount;
    state.orderData = orderData;
};

export const setInsuranceStatus = (state, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['insurance_status'] = payload;
    state.orderData = orderData;
};

export const setReturnDate = (state, payload) => {
    state.orderData[state.activeOrderDataIndex]['return_date'] = payload;
};

export const setCountryPackages = (state, payload) => {
    state.countryPackages = payload;
};

export const setPlanDevices = (state, payload) => {
    state.planDevices = payload;
};

export const setActiveOrderDataIndex = (state, payload) => {
    state.activeOrderDataIndex = payload;
};

export const setOrderData = (state, payload) => {
    state.orderData = payload;
    localStorage.setItem("orderData", JSON.stringify(state.orderData));
};

export const clearOrderData = (state) => {
    state.selectedDevice = {};
    state.orderData = [];
    localStorage.removeItem("orderData");
};

export const setPickupLocations = (state, payload) => {
    state.pickupLocations = payload;
};

export const setDestinations = (state, payload) => {
    state.destinations = payload;
};